import "campthree/campthree-frontend";

class AwwwScrollPos {
    constructor() {
        this._currentDir = "";
        this._currentPos = window.scrollY;
        this._timer = null;
        this.init();
    }

    init() {
        if (this._currentPos <= 10) {
            
            document.body.classList.add("scroll-top");
            document.body.classList.remove("scroll-stopped");
        }

        document.addEventListener("scroll", () => this.onScroll(), {passive: true});
    }

    onScroll() {
        const scrollPos = window.scrollY;
        const direction = scrollPos > this._currentPos ? "down" : scrollPos < this._currentPos ? "up" : "stopped";

        if (direction !== this._currentDir) {
            this._currentDir = direction;
            document.body.classList.toggle("scroll-down", direction === "down");
            document.body.classList.toggle("scroll-up", direction === "up");
            document.body.classList.toggle("scroll-stopped", direction === "stopped");
        }

        clearTimeout(this._timer);
        this._timer = setTimeout(() => {
            this._currentDir = "stopped";
            document.body.classList.add("scroll-stopped");
            document.body.classList.remove("scroll-down", "scroll-up");
        }, 1000);

        document.body.classList.toggle("scroll-top", scrollPos <= 10);
        this._currentPos = scrollPos;
    }
}

const scrollPos = new AwwwScrollPos();

window.onload = function () {

    const awwwAriaControlsHolder = new AwwwAriaControlsHolder();
    document.addEventListener("AWWW_PAGE_RELOAD_FIRST", function () {
        const awwwAriaControlsHolder = new AwwwAriaControlsHolder();
    });

   
};

class AwwwAriaControlsHolder {
    constructor() {
        this._controlledItems = {};
        this.activeItems = [];
        this.initAriaControls();

        this.enableEvents();
    }

    enableEvents() {
        document.addEventListener("click", (e) => {
            if (!e.hasOwnProperty("ariaClicked") && this.activeItems.length > 0) {
                this.activeItems.forEach((item) => {
                    if (!item.contains(e.target)) {
                        item.dispatchEvent(new CustomEvent("STATE_CHANGED", {bubbles: false, detail: {state: false, affectedItems: []}}));
                    }
                });
                this.activeItems = [];
            }
        });

        document.addEventListener("STATE_CHANGED", (e) => {
            if (e.detail.hasOwnProperty("affectedItems") && e.detail.affectedItems.length > 0) {
                this.activeItems = e.detail.affectedItems;
            } else {
                this.activeItems = [];
            }
        });

        document.addEventListener("focusin", (e) => {
            if (this.activeItems.length) {
                this.activeItems.forEach((item) => {
                    if (!item.contains(e.target) && e.target != item) {
                        item.dispatchEvent(new CustomEvent("STATE_CHANGED", {bubbles: true, detail: {state: false, affectedItems: []}}));
                    }
                });
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.keyCode == 27 && this.activeItems.length > 0) {
                document.querySelector('[aria-controls*="' + this.activeItems[0].id + '"]').focus();
            }
        });

        document.addEventListener("AWWW_REGISTER_CONTROLS", (e) => {
            
            this.initAriaControls(e.detail.section);
        });
    }

    // Initialize aria controls within a given section (or document by default)
    initAriaControls(section = document) {


        section.querySelectorAll("[aria-controls]").forEach((button) => {
            
            const ids = button.getAttribute("aria-controls").split(' ');
            const objects = this.getControlledItems(ids);

            // Determine the type of button based on the attributes and create the appropriate control button
            this.createControlButton(button, ids, objects);
        });

    }

    // Retrieve controlled items based on the ids
    getControlledItems(ids) {
        return ids.map(id => {
            if (this._controlledItems[id]) {
                return this._controlledItems[id];
            }
            const element = document.getElementById(id);
            if (element) {
                const newItem = new AwwwControlledItem(id, element);
                this._controlledItems[id] = element;
                return element;
            }

            return null;
        }).filter(Boolean);
    }

    // Create the appropriate aria control button based on the button's attributes
    createControlButton(button, ids, objects) {
        if (button.hasAttribute("data-parent")) {
            const parent = document.getElementById(button.getAttribute("data-parent"));
            new AwwwAriaControlButtonParent(button, ids, objects, parent);
        } else if (button.hasAttribute("data-dir")) {
            const dir = button.getAttribute("data-dir");
          
            new AwwwAriaControlButtonDirectional(button, ids, objects, dir);
        } else if (button.hasAttribute("data-pos")) {
            const pos = button.getAttribute("data-pos");
           
            
            new AwwwAriaControlButtonPositional(button, ids, objects, pos);
        } else {
            new AwwwAriaControlButtonNormal(button, ids, objects);
        }
    }
}

class AwwwAriaControlButtonBase {
    constructor(button, controlledIds, controlledItems) {
        this._button = button;
        this._ids = controlledIds;
        this._controlledItems = controlledItems;
        this._changed = false;
        this._controlledItems.forEach(item => this.activateChange(item));
    }

    activateChange(item) {
        item.addEventListener("STATE_CHANGED", (e) => {
            let active = (e.target == item) ? e.detail.state : "true";
            this._button.setAttribute("aria-expanded", active);

            this._changed = true;
        });
    }
}

class AwwwAriaControlButtonNormal extends AwwwAriaControlButtonBase {
    constructor(button, controlledIds, controlledItems) {
        super(button, controlledIds, controlledItems);
        this.activateNormalHandling();
    }

    activateNormalHandling() {
        this._button.addEventListener("click", (e) => {
            e.preventDefault();
            e.ariaClicked = true;

            const isExpanded = this._button.getAttribute("aria-expanded") === "true";

            this.changeState(!isExpanded);
        });

        this._button.addEventListener("focusin", (e) => {
            if (this._button.getAttribute("aria-expanded") === "true") {
                e.stopPropagation();
            }
        });

        document.addEventListener("STATE_CHANGED", () => {
            if (!this._changed) {
                this._button.setAttribute("aria-expanded", "false");
                this._controlledItems.forEach(item => {
                    item.dispatchEvent(new CustomEvent("STATE_CHANGED", {bubbles: false, detail: {state: false}}));
                });
            }
            this._changed = false;
        });
    }

    changeState(state) {
        this._controlledItems.forEach(item => {
            item.dispatchEvent(new CustomEvent("STATE_CHANGED", {bubbles: true, detail: {state: state, affectedItems: []}}));
        });
    }
}

class AwwwAriaControlButtonParent extends AwwwAriaControlButtonBase {
    constructor(button, controlledIds, controlledItems, parent) {
        super(button, controlledIds, controlledItems);
        this._parent = parent;
        this.initializeDefaultState();
        this.activateParentHandling();
    }

    initializeDefaultState() {
        if (!this._parent || !this._parent.hasAttribute("data-child-open")) {
            return;
        }

        const parentButtons = Array.from(this._parent.querySelectorAll("[data-parent]"));
        const isFirstChild = parentButtons.findIndex((node) => node === this._button) === 0;
        const shouldOpen = this._parent.getAttribute("data-child-open") === "true" && isFirstChild;

        this._button.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
        this._controlledItems.forEach(item => {
            item.dispatchEvent(new CustomEvent("STATE_CHANGED", {bubbles: false, detail: {state: shouldOpen}}));
        });
    }

    activateParentHandling() {
        this._button.addEventListener("click", (e) => {
            e.preventDefault();
            this._parent.dispatchEvent(new CustomEvent("STATE_CHANGED", {bubbles: true, detail: {state: true, target: this._button}}));
        });

        this._parent.addEventListener("STATE_CHANGED", (e) => {
            const isSameButton = e.detail.target === this._button;
            this._button.setAttribute("aria-expanded", isSameButton ? "true" : "false");
            this._controlledItems.forEach(item => {
                item.dispatchEvent(new CustomEvent("STATE_CHANGED", {bubbles: false, detail: {state: isSameButton}}));
            });
        });
    }
}

class AwwwAriaControlButtonDirectional extends AwwwAriaControlButtonBase {
    constructor(button, controlledIds, controlledItems, dir) {
        super(button, controlledIds, controlledItems);
        this._dir = dir;
        this.activateDirectionalHandling();
    }

    activateDirectionalHandling() {
        this._controlledItems.forEach(item => {
            item.addEventListener("AWWW_CHANGED_ITEM", (e) => {
                this._button.disabled = (this._dir === "-1" && e.detail.start) || (this._dir === "+1" && e.detail.end);
            });
        });

        this._button.addEventListener("click", (e) => {
            e.preventDefault();
            this._controlledItems.forEach(item => {
                item.dispatchEvent(new CustomEvent("AWWW_CHANGE_DIR", {detail: {dir: this._dir}}));
            });
        });
    }
}

class AwwwAriaControlButtonPositional extends AwwwAriaControlButtonBase {
    constructor(button, controlledIds, controlledItems, pos) {
        super(button, controlledIds, controlledItems);
        this._pos = pos;
        this.activatePositionalHandling();
    }

    activatePositionalHandling() {
        const posAttribute = this._button.getAttribute('data-pos');

        this._controlledItems.forEach(item => {
            item.addEventListener("AWWW_CHANGED_ITEM", (e) => {
                const isSelected = e.detail.pos == posAttribute;
                this._button.setAttribute("aria-selected", isSelected);
            });
        });

        this._button.addEventListener("click", (e) => {
            e.preventDefault();

            this._controlledItems.forEach(item => {
                item.dispatchEvent(new CustomEvent("AWWW_CHANGE_POS", {detail: {pos: this._pos}}));
            });
        });
    }
}

class AwwwControlledItem {
    constructor(id, item) {
        this._id = id;
        this._item = item;
        this._firstFocusableChild = this._item.querySelector("a, input, button");

        if (this._item.getAttribute("role") === "dialog") {
            this.setupDialogFocusManagement();
        }

        this._item.addEventListener("STATE_CHANGED", (e) => {
            this.handleStateChanged(e);
        });

        this._item.addEventListener("click", (e) => {
            e.ariaClicked = true;
        });
    }

    handleStateChanged(e) {
        const isSameItem = e.target === this._item;
        const state = isSameItem ? e.detail.state === true : true;

        this._item.classList.toggle('active', state);

        if (isSameItem && state == true && this._firstFocusableChild) {
            this._firstFocusableChild.focus();
        }

        if (state == true && e.detail.hasOwnProperty("affectedItems")) {
            e.detail.affectedItems.push(this._item);
        }
    }

    setupDialogFocusManagement() {
        const focusableElements = Array.from(this._item.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
        this._firstElement = focusableElements[0];
        this._lastElement = focusableElements[focusableElements.length - 1];

        this._item.addEventListener("keydown", (e) => {
            if (e.key === "Tab") {
                if (e.shiftKey && document.activeElement === this._firstElement) {
                    e.preventDefault();
                    this._lastElement.focus();
                } else if (!e.shiftKey && document.activeElement === this._lastElement) {
                    e.preventDefault();
                    this._firstElement.focus();
                }
            }
        });
    }
}

